
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/[id]/compare",
      function () {
        return require("private-next-pages/category/[id]/compare/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category/[id]/compare"])
      });
    }
  